import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Badge,
  Spinner
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const QuizStatusModal = ({ isOpen, toggle, flashCardId, dishName }) => {
  const [loading, setLoading] = useState(false);
  const [servers, setServers] = useState([]);

  useEffect(() => {
    console.log(flashCardId);
    
    if (!isOpen || !flashCardId) return;

    setLoading(true);

    postDataAPI({
      serviceName: "server_data",
      op: "get-assigned-servers",
      flash_card_id: flashCardId
    })
      .then((res) => {
        if (res.status === "ok") {
          setServers(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, [isOpen, flashCardId]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>
        🏆 Quiz Status: {dishName}
      </ModalHeader>

      <ModalBody>
        {loading ? (
          <div className="text-center py-4">
            <Spinner size="sm" /> Loading...
          </div>
        ) : (
          <Table borderless className="align-middle mb-0">
            <thead className="text-muted small">
              <tr>
                <th>Server Name</th>
                <th className="text-center">Taken</th>
                <th className="text-center">Score</th>
              </tr>
            </thead>
            <tbody>
              {servers.length === 0 && (
                <tr>
                  <td colSpan="3" className="text-center text-muted py-3">
                    No servers assigned
                  </td>
                </tr>
              )}

              {servers.map((row) => (
                <tr key={row.server_id}>
                  <td>{row.server_name}</td>

                  <td className="text-center">
                    {row.quiz_complete ? (
                      <Badge pill color="success">
                        Y
                      </Badge>
                    ) : (
                      <Badge pill color="secondary">
                        N
                      </Badge>
                    )}
                  </td>

                  <td className="text-center">
                    {row.quiz_complete ? (
                      <Badge pill color="primary">
                        {row.score}/{row.total_questions}
                      </Badge>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
    </Modal>
  );
};

export default QuizStatusModal;
